Vue.directive('rowaction', {
  // When the bound element is inserted into the DOM...
  bind(el, binding) {
    el.addEventListener('click', function(event) {
      event.preventDefault();
      window.rowaction({
        position: calculatePosition(event),
        data: binding.value
      });
    });
  },
  update(el, binding) {
    if (binding.oldValue.id === binding.value.id) return;
    el.addEventListener('click', function(event) {
      event.preventDefault();
      window.rowaction({
        position: calculatePosition(event),
        data: binding.value
      });
    });
  }
});

function calculatePosition(e) {
  const offset = { x: 30, y: 30 };
  const rect = e.target.getBoundingClientRect();
  const _scrollY = window.scrollY || window.pageYOffset;
  const _scrollX = window.scrollX || window.pageXOffset;
  return {
    left: `${_scrollX + rect.left - offset.x}px`,
    top: `${_scrollY + rect.top + offset.y}px`
  };
}
